import styled from 'styled-components';

export const SearchBoxStyled = styled.div`
  width: 100%;
  position: relative;

  .react-autosuggest__suggestions-container {
    display: none;
  }


  .viewAllButtonContainer {
    width: 625px;
    height: 43px;
    padding: 12px 0px;
    border: 1px 0px 0px 0px;
    gap: 10px;
    border-top: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto; /* Allow the button to take the available width */
    justify-content: center;
  }
  .viewAllButtonText {
    width: 116px;
    height: 19px;
    font-family: 'Mulish';
    font-size: 15px;
    font-weight: 700;
    line-height: 19px;
    letter-spacing: 0em;
    text-align: center;
    color: #388E3C;
    cursor: pointer;
  }
  .highlighted-text {
    font-weight: normal;
    height: 20px;
    font-family: Mulish;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    padding-left:25px;
    
    
  }
  .individual-keyword-title {
    gap: 100px;
    font-weight: normal;
    height: 35px;
    font-family: Mulish;
    font-size: 16px;
    line-height: 15px;
    letter-spacing: 0em;
    text-align: left;
    padding-left:18px;
    padding-top:10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 600px; 
  }
  .individual-product-title {
    gap: 100px;
    font-weight: normal;
    height: 35px;
    font-family: Mulish;
    font-size: 16px;
    line-height: 15px;
    letter-spacing: 0em;
    text-align: left;
    padding-left:10px;
    padding-top:10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 600px; 
  }
  .individual-container {
    padding: 0px;
    margin-top: 2px 
  }
  .match {
    font-weight: bold;
    
  }
  .customDivider {
    width: 100%;
    height: 1px;
    background: ${(props) => props.theme.color.divider};
    margin: 0 auto;
  }
  .product-container {
    display: flex;
    align-items: center;
    margin-left: 24px;
  }
  .product-icon {
    width: 30px;
    height: 30px;
    
  }
  .keyword-container{
    display: flex;
    align-items: center;
    margin-left: 24px;
  }
  .keyword-icon{
    width: 24px;
    height: 24px;
  }
  
  .union-logo-container {
    position: absolute;
    display: flex;
    align-items: center;
    position: absolute;
    left: 39px;
    margin-bottom: 12px;
}

  .react-autosuggest__suggestions-container--open {
    display: block;
  }

  .react-autosuggest__input {
    width: 100%;
    padding:12px 40px;

    &:focus {
      outline: none;
    }
  }

  .react-autosuggest__input::placeholder {
    text-overflow: ellipsis;
  }

  #react-autowhatever-1 {
    max-height: 450px;
    overflow-y: auto;

    &.epharmacy {
      max-height: 255px;
      overflow-y: auto;
    }
  }

  .react-autosuggest__suggestions-list {
    padding: 0;
    margin: 0;
    list-style: none;
    overscroll-behavior: contain;

    li {

      color: ${(props) => props.theme.text.medium};
      border-bottom: 1px solid ${(props) => props.theme.color.border};
      width: 100%;
      height: 40px;
      cursor: pointer;
      font-size: 16px;

      &:last-child {
        border-bottom: 0;
      }
      .highlight {
        color: ${(props) => props.theme.text.dark};
        font-weight: 700;
      }
      .searchText {
        font-size: 15px;
        font-weight: 600;
      }
      .category {
        font-size: 14px;
      }
    }
  }

  .react-autosuggest__suggestion--highlighted {
    color: ${(props) => props.theme.text.dark};
    background: ${(props) => props?.theme?.color?.extraLightGray};
  }

  .noData {
    width: 100%;
    height: 140px;
    position: relative;
    padding: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .ic {
      width: 67px;
      height: 67px;
      position: relative;
      top: 0;
      left: 0;
      margin: 0 30px 0 0;
    }

    .details {
      width: 100%;
      display: flex;
      flex-direction: column;

      .title {
        font-size: 18px;
        font-weight: 700;
      }

      .description {
        font-size: 14px;
        font-weight: 600;
        color: ${(props) => props.theme.text.medium};
      }
    }
  }

  .searchMenu {
    width: 100%;
    min-height: 100px;
    background: ${(props) => props.theme.color.white};
    border: 1px solid ${(props) => props.theme.color.borderLight};
    border-radius: 8px;
    position: absolute;
    top: calc(100% + 4px);
    left: 0;

    .lnkClear {
      position: absolute;
      top: 24px;
      right: 24px;
      color: ${(props) => props.theme.blue.dark};
      text-decoration: none;
      font-size: 15px;
      font-weight: 700;

      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }

    .tags {
      width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      .tag {
        color: ${(props) => props.theme.text.dark};
        padding: 10px 12px;
        border: 1px solid ${(props) => props.theme.color.border};
        border-radius: 5px;
        margin: 0 8px 8px 0;
        text-decoration: none;
        background: ${(props) => props.theme.sectionBox.bodyBg};
        font-weight: 600;

        &:hover {
          cursor: pointer;
          background: ${(props) => props.theme.color.divider};
        }
      }
    }

    .searchList {
      margin: 0;
      padding: 0;
      list-style: none;

      li {
        color: ${(props) => props.theme.text.dark};
        font-size: 16px;
        font-weight: 400;
        display: flex;
        border-bottom: 1px solid ${(props) => props.theme.color.border};

        &:last-child {
          border-bottom: 0;
        }

        &:first-child {
          margin-top: -13px;
        }

        a {
          width: 100%;
          display: flex;
          color: ${(props) => props.theme.text.dark};
          text-decoration: none;
          padding: 12px 0 12px 0;
          position: relative;

          &:hover {
            color: ${(props) => props.isEpharmacyPage ? props.theme.green.dark : props.theme.blue.dark};
          }

          &::after {
            content: '';
            width: 12px;
            height: 6px;
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%) rotate(-90deg);
          }
        }
      }
    }

    .divider {
      width: 100%;
      height: 2px;
      background: ${(props) => props.theme.color.divider};
    }
    .section_divider {
      width: 100%;
      height: 1px;
      background: ${(props) => props.theme.color.divider};
    }
    .box {
      padding: 16px;

      .title {
        font-size: 17px;
        font-weight: 700;
        color: ${(props) => props.theme.text.dark};
        margin-bottom: 24px;
      }
    }

    .searchLine {
      width: 173.31776428222656px;
      height: 20px;
      font-family: Mulish;
      font-size: 15px;
      font-weight: 600;
      line-height: 38px;
      letter-spacing: 0px;
      text-align: left;
      white-space: nowrap;
      color: ${(props) => props.theme.text.medium};

      strong {
        color: ${(props) => props.theme.text.dark};
      }
    }
  }
  .react-autosuggest__suggestion-match {
    color: black;
    font-weight: 700;
  }

  .icSearch {
    width: 18px;
    position: absolute;
    top: 15px;
    right: 15px;
    z-index: 1;
    cursor: pointer;
    left: 15px;
    
    &.hcCrossSearch {
      right: 12px;
      left: auto;
      width: 12px;
    }
  }

  .icGlobalSearch {
    width: 18px;
    position: absolute;
    top: 15px;
    right: auto;
    z-index: 1;
    cursor: pointer;
    left: 15px;

    &.icCrossSearch {
      right: 12px;
      left: auto;
      width: 12px;
    }
  }

  input {
    font-size: 14px;
    padding: 12px 40px 12px 10px;
    background: ${(props) => props.theme.blue.extraLight};
    border: 1px solid ${(props) => props.theme.color.divider};
    border-radius: 6px;

    &:focus {
      background: ${(props) => props.theme.blue.extraLight};
    }
  }
  .borderBottomRadius {
    border-bottom-right-radius: 8px;
    overflow: hidden;
  }
  .search-box-label {
    background: #f2f8fd;
    border-top-right-radius: 7px;
    border-top-left-radius: 7px;
    font-weight: 700;
    font-size: 14px;
    color: ${(props) => props.theme.grey.dark};
    padding: 8px 8px 8px 16px;
    justify-content: space-between;
    height: 36px;
    line-height: 18px;

    &.epharmacy {
      background: ${(props) => props.theme.green.off};
      border-top-right-radius: 0px;
      border-top-left-radius: 0px;
    }

    &.hc {
      background: ${(props) => props.theme.royalBlue.off};
      border-top-right-radius: 0px;
      border-top-left-radius: 7px;
    }
  }
  .search-view-blue {
    font-weight: 700;
    font-size: 14px;
    color: ${(props) => props.theme.blue.dark};
    display: flex;
    align-items: center;
    margin-bottom: 2px;
    .ic-arrow {
      width: 11px;
      display: flex;
      align-items: center;
    }
    &.epharmacy {
      color: ${(props) => props.theme.green.dark};
      margin-left: 2px;
      gap: 2px;
      margin-right: 4px;
      margin-bottom: 2px;
    }
    &.hc {
      color: ${(props) => props.theme.royalBlue.dark};
      margin-left: 2px;
      gap: 2px;
      margin-right: 4px;
      
    }
    .ic-arrow {
      border: solid ${(props) => props.theme.blue.dark};
      border-width: 0 1.99px 1.99px 0;
      display: inline-block;
      padding: 5px 2px 2px 5px;
      margin-left: 2px;
      width: 9px;
      height: 8px;
      gap: 2px;
      margin-right: 4px;
      border-radius: 1.33px;
      margin-bottom: 2px;
      &.right {
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
      }
      &.epharmacy {
        border-color: ${(props) => props.theme.green.dark};
        margin-left: 2px;
        gap: 2px;
        margin-right: 4px;
        margin-bottom: 2px;
      }
      &.hc {
        border-color: ${(props) => props.theme.royalBlue.dark};
        margin-left: 2px;
        gap: 2px;
        margin-right: 4px;
        margin-bottom: 2px;
      }
    }
  }
  .search-box-global-wrapper {
    max-height: unset !important;
    overflow-y: auto;
    .search-box-global-box {
      overflow: auto;
      max-height: calc(100vh - 50px);
      #search-box-global-wrapper {
        overflow: auto;
      }
    }
    #react-autowhatever-1 {
      max-height: unset;
      overflow-y: unset;

      &.epharmacy {
        max-height: unset;
        overflow-y: unset;
      }
    }
  }
  .search-box-global {
    &.epharmacy {
      .react-autosuggest__suggestions-list li {
        padding: 8px 16px;
        color: ${(props) => props.theme.text.medium};
        border-bottom: 0px;
        cursor: pointer;
        font-size: 16px;
        &:hover {
          color: ${(props) => props.theme.green.dark};
          background-color: transparent;
          .highlight {
            color: ${(props) => props.theme.green.dark};
          }
        }
      }
    }
    &.hc {
      .react-autosuggest__suggestions-list li {
        padding: 8px 16px;
        color: ${(props) => props.theme.text.medium};
        border-bottom: 0px;
        cursor: pointer;
        font-size: 16px;
        &:hover {
          color: ${(props) => props.theme.royalBlue.dark};
          background-color: transparent;
          .highlight {
            color: ${(props) => props.theme.royalBlue.dark};
          }
        }
      }
    }
    .react-autosuggest__suggestions-list li {
      padding: 8px 16px;
      color: ${(props) => props.theme.text.medium};
      border-bottom: 0px;
      cursor: pointer;
      font-size: 16px;
      font-weight: 600;

      &:hover {
        color: ${(props) => props.theme.blue.dark};
        background-color: transparent;
        .highlight {
          color: ${(props) => props.theme.blue.dark};
        }
      }
    }
  }
  @media (max-width: 767px) {
    .viewAllButtonContainer {
      width: auto; 
      justify-content: center; 
    }
    .search-box-global-wrapper {
      max-height: 88vh !important;
      overflow-y: auto;
      #react-autowhatever-1 {
        max-height: unset;

        &.epharmacy {
          max-height: unset;
        }
      }
    }
  }
  @media (max-width: 575px) {
    .react-autosuggest__suggestions-list {
      overscroll-behavior: contain;
    }
    .search-box-global-wrapper {
      max-height: 50vh !important;
      overflow-y: scroll !important;
      scroll-behavior: smooth;
      overscroll-behavior: contain;
      #react-autowhatever-1 {
        max-height: unset;
        overflow-y: scroll;
        scroll-behavior: smooth;

        &.epharmacy {
          max-height: unset;
          overflow-y: scroll;
          scroll-behavior: smooth;
        }
      }
    }

    input {
      padding: 12px 40px;
    }

    .icSearch {
      left: 15px;
    }
  }
  &.rtl {
    .product-container {
      margin: 0 24px 0 0;
      gap: 18px;
    }
    .keyword-container{
      margin: 0 24px 0 0;
      gap: 18px;
    }
    .individual-keyword-title {
      padding:left: 0;
    }
  }
`;
